import {BrowserRouter, Routes, Route} from 'react-router-dom';
import '@fontsource/roboto/400.css';
import './App.css';
import './bootstrap-grid.min.css';
import Footer from './components/Footer';
import Register from './components/Register';
import Login from './components/Login';
import Logout from './components/Logout';
import Dashboard from './components/Dashboard';
import User from './components/User';
import UserList from './components/UserList';
import UserEdit from './components/UserEdit';
import ProductoList from './components/ProductoList';
import ProductoAMC from './components/ProductoAMC';
import PedidosList from './components/PedidosList';
import Carta from './components/Carta';
import SucursalesList from './components/SucursalesList';
import UsuarioAccionesList from './components/UsuarioAccionesList';
import CuponesList from './components/CuponesList';
import AuditoriaList from './components/AuditoriaList';
import ErroresList from './components/ErroresList';
import React, { useState, useEffect } from 'react';
function App() {

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    });
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
      });
    }
  };

  return (
    <div>
  {showInstallPrompt && (
        <button onClick={handleInstallClick}>
          Instalar aplicación
        </button>
      )}
        <BrowserRouter>
          <Routes>
            <Route index element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/dashboard" element={<Dashboard />} />
           
            <Route path="/userList" element={ <UserList />} />
            <Route path="/user" element={ <User />} />
            <Route path="/userEdit" element={ <UserEdit />} />

            <Route path="/Carta" element={ <Carta />} />

            <Route path="/productoList" element={ <ProductoList />} />
            <Route path="/productoAMC" element={ <ProductoAMC />} />
            <Route path="/pedidosList" element={ <PedidosList />} />
            <Route path="/sucursalesList" element={ <SucursalesList />} />
            <Route path="/UsuarioAccionesList" element={ <UsuarioAccionesList />} />
            <Route path="/CuponesList" element={ <CuponesList />} />

            <Route path="/AuditoriaList" element={ <AuditoriaList />} />
            <Route path="/ErroresList" element={ <ErroresList />} />
            
           

          </Routes>
        </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;